<template>
  <div class="container-fluid articles">
    <div class="row">
      <bimContainer>
        <bimRow justify="center">
          <bimCol
            class="mt-md-9 pt-md-1"
            cols="12"
            sm="9"
            xl="6"
          >
            <img alt="" :src="logo" class="single-case__logo" />
            <bimTextMedium bold class="case__title-info pl-0 pl-md-9">
              <a href="/cases">
                <img alt="" src="/dist/assets/front_white/img/svg/arrow-left-grey.svg" />
                <span class="case__title-link ml-2">Все кейсы</span>
              </a>
            </bimTextMedium>
            <bimTextH5 class="ml-md-9 case__title" bold>{{ article.title }}</bimTextH5>
            <BimTag :label="tagText" nohover class="mt-6 mb-9 ml-md-9" />
            <CaseHeader :data="article" class="case-header" />
            <CaseContent :data="article" />
            <BlockActionTime @showModal="showModal = true" class="cases__action-time" />
            <VolumeOfActivity v-show="false" :data="[{ name: 'aserdsadff', count: 23 },{ name: 'faasdfdf', count: 23 },{ name: 'asasdfasdf', count: 23 }]" />
            <NextCase v-if="nextCase" :data="nextCase" />
          </bimCol>
        </bimRow>
      </bimContainer>
    </div>
    <bimPhoneRequest
      v-model="showModal"
      :userContext="user_info"
      :logActionEvent="$logActionEvent"
      apiPrefix="/web-api-2"
      :formType="2"
    />
  </div>
</template>

<script>
import bimRow from "@bimlib/components/bimRow"
import bimCol from "@bimlib/components/bimCol"
import bimContainer from "@bimlib/components/bimContainer"

import bimTextH5 from "@bimlib/components/bimTextH5"
import bimTextMedium from "@bimlib/components/bimTextMedium"
import bimPopup from "@bimlib/components/bimPopup"

import CaseHeader from "@/pages/articles/components/article/Header"
import CaseContent from "@/pages/articles/components/article/Content"
import BlockActionTime from "@/pages/static/smpp/components/BlockActionTime"
import NextCase from "./NextCase"
import VolumeOfActivity from "./VolumeOfActivity"
import BimTag from "@/athoms/BimTag"
import bimPhoneRequest from '@bimlib/components/bimPhoneRequest'

export default {
  components: {
    bimRow,
    bimCol,
    bimContainer,
    bimTextH5,
    bimTextMedium,
    bimPopup,
    CaseHeader,
    CaseContent,
    BlockActionTime,
    NextCase,
    VolumeOfActivity,
    BimTag,
    bimPhoneRequest
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    user_info: Object,
  },
  data() {
    return {
      showModal: false,
      nextCase: null,
      manId: 0,
      logo: "",
    }
  },
  async created() {
    const cases = await this.getNextCase()
    this.nextCase = cases.next
    this.manId = cases.current.id
    this.logo = cases.current.lang_versions[1].image
  },
  methods: {
    async getNextCase() {
      let cases = await this.$store.dispatch('getCasesList')
      cases = cases.filter(c => c.lang_versions[1].status_lang === "Published")

      const lastCaseIndex = cases.length - 1

      let currentCaseIndex = cases.findIndex(_case => {
        return _case.lang_versions[1].content_id === this.article.content_id
      })

      return {
        next: currentCaseIndex === lastCaseIndex ? cases[0] : cases[currentCaseIndex + 1],
        current: cases[currentCaseIndex],
      }
    }
  },
  computed: {
    tagText() {
      return this.article.tags_lang
    }
  }
};
</script>

<style lang="scss" scoped>
.case__title-info {
  line-height: 1.36;
  padding: 14px 24px 14px;
  &:hover {
    opacity: .8;
  }
}

.case__title-link {
  opacity: .5;
}

.case__title ::v-bind .text__inner {
  @media screen and (max-width: 576px) {
    font-size: 20px !important;
  }
}

.case-header {
  ::v-deep .article-header__info {
    display: none;
  }
  ::v-deep .article-header__title {
    display: none;
  }
}

.send-request__popup {
  ::v-deep .modal-body {
    max-height: none !important;
  }
  ::v-deep .modal-content {
    width: 100%;
  }
}

.cases__action-time {
  ::v-deep .bim-col {
    width: 100% !important;
    flex: 0 0 100% !important;
  }
}

.single-case__logo {
  object-fit: contain;
  min-width: 108px;
  min-height: 108px;
  width: 108px;
  height: 108px;
  display: block;
  margin: auto;
  @media screen and (max-width: 576px) {
    min-width: 144px;
    min-height: 144px;
    width: 144px;
    height: 144px;
  }
}
</style>
